import React from "react";
import ReactDOM from "react-dom";

import { Provider } from "react-redux";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

import uaLocale from "date-fns/locale/uk";
import ruLocale from "date-fns/locale/ru";
import enLocale from "date-fns/locale/en-US";
import eeLocale from "date-fns/locale/et";
import roLocale from "date-fns/locale/ro";


import { RootRoute } from "./routes";
import * as serviceWorker from "./serviceWorker";
import { ConnectedRouter } from "connected-react-router";
import store from "./store";
import history from "./history";
import "./index.css";
import "./i18n.js";
import i18n from 'i18next';

const localeMap = {
  ua: uaLocale,
  en: enLocale,
  ru: ruLocale,
  ee: eeLocale,
  ro: roLocale,
};
ReactDOM.render(
  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[i18n.language]}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <RootRoute />
      </ConnectedRouter>
    </Provider>
  </MuiPickersUtilsProvider>,
  document.getElementById("root")
);

serviceWorker.unregister();
